import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useState } from 'react';

import type { ActiveCell } from './tableSelection';
import { $readActiveCell } from './tableSelection';

/** The selected cell's state for the cell menu, or `null` when the selection isn't in a table. */
export const useActiveTableCell = (): ActiveCell | null => {
  const [editor] = useLexicalComposerContext();
  const [active, setActive] = useState<ActiveCell | null>(null);

  useEffect(() => editor.registerUpdateListener(({ editorState }) => setActive(editorState.read($readActiveCell))), [editor]);

  return active;
};
